import { createContext, useContext, JSX } from "solid-js";

// French translations
const translations = {
  // Navigation & Common
  "Pre-Stage": "Pré-Stage",
  "Home": "Accueil",
  "Admin": "Administration",
  "Settings": "Paramètres",
  "Logout": "Déconnexion",
  
  // User Profile
  "Please enter your full name": "Veuillez entrer votre nom complet",
  "Enter your full name": "Entrez votre nom complet",
  "Save": "Enregistrer",
  "Saving...": "Enregistrement...",
  "Error updating profile. Please try again.": "Erreur lors de la mise à jour du profil. Veuillez réessayer.",
  "Complete Your Profile": "Complétez votre profil",
  "Please set your full name to continue. This will be displayed to other users.": 
    "Veuillez définir votre nom complet pour continuer. Il sera affiché aux autres utilisateurs.",
  "Please complete your profile information before creating internship agreements:": 
    "Veuillez compléter votre profil avant de créer des pré-conventions de stage :",
  "Please also verify that your email address is correct.": 
    "Veuillez également vérifier que votre adresse email est correcte.",
  "Go to Settings": "Aller aux paramètres",
  "Student Number": "Numéro étudiant",
  "Enter your student number": "Entrez votre numéro étudiant",
  "Your student number for administrative purposes.": "Votre numéro étudiant pour les besoins administratifs.",
  "Health Insurance - City + Region": "Caisse d'assurance maladie - Ville + Région",
  "e.g., CPAM Strasbourg - Grand Est": "ex: CPAM Strasbourg - Grand Est",
  "Your health insurance fund with city and region.": "Votre caisse d'assurance maladie avec ville et région.",
  "Internship Management Platform": "Plateforme de gestion des stages",
  "Email Address": "Adresse email",
  "Your login username cannot be changed.": "Votre nom d'utilisateur de connexion ne peut pas être modifié.",
  "Your full name will be displayed to other users.": "Votre nom complet sera affiché aux autres utilisateurs.",
  "Your email address cannot be changed. Contact an administrator if it needs to be updated.": "Votre adresse email ne peut pas être modifiée. Contactez un administrateur si elle doit être mise à jour.",
  "Your class determines who can validate your internship agreements.": "Votre classe détermine qui peut valider vos conventions de stage.",
  "Profile Information": "Informations du profil",
  "Class Information": "Informations sur votre classe",
  "Account Actions": "Actions du compte",
  "This is your default email based on your username and role. You can change it if needed.": "Ceci est votre email par défaut basé sur votre nom d'utilisateur et votre rôle. Vous pouvez le changer si nécessaire.",


  // Promo Selector
  "Select your promotion": "Sélectionnez votre promotion",
  "Please select your promotion to continue": "Veuillez sélectionner votre promotion pour continuer",
  "Select Promotion": "Sélectionner la promotion",
  "Welcome to the Internship Management Platform": "Bienvenue sur la plateforme de gestion des stages",
  "Before you can create internship agreements, please select your class/promo:":
    "Avant de créer des pré-conventions de stage, veuillez sélectionner votre classe/promotion :",
  "Select your class:": "Sélectionnez votre classe",
  "Choose a class": "Choisissez une classe",
  "Confirm Selection": "Confirmer la sélection",
  
  // Conventions
  "Internship Agreements": "Pré-conventions",
  "Your Internship Agreements": "Vos pré-conventions",
  "Internship Agreement": "Pré-convention",
  "Create New Agreement": "Créer une nouvelle pré-convention",
  "Draft Agreements": "Pré-conventions en cours de rédaction",
  "Pending Validation": "En attente de validation",
  "Validated Convention": "Pré-convention validée",
  "Active Convention": "Pré-convention active",
  "Archived Agreements": "Pré-conventions archivées",
  "Archived Conventions": "Pré-conventions archivées",
  "Not specified": "Non spécifié",
  "Previous Feedback": "Retours précédents",
  "You have received feedback on earlier versions of this convention.": "Vous avez reçu des retours sur des versions antérieures de cette pré-convention.",
  "Convention Status Guide": "Guide des statuts de pré-convention",
  "Private to you": "Privé",
  "Visible to teachers": "Visible par les enseignants",
  "Fully approved": "Entièrement approuvée",
  "Inactive": "Inactive",
  "Edit and prepare your convention": "Modifiez et préparez votre pré-convention",
  "Awaiting teacher validation": "En attente de validation enseignant",
  "Awaiting validation": "En attente de validation",
  "All teachers have validated": "Tous les enseignants ont validé",
  "Stored for reference": "Archivée pour référence",
  "Process": "Traiter",
  "You already have an active convention. To create a new one, you need to archive your current active convention.":
    "Vous avez déjà une pré-convention active. Pour en créer une nouvelle, vous devez archiver votre pré-convention actuelle.",
  "You already have a locked convention. You cannot create new conventions while having a locked one.": "Vous avez déjà une pré-convention verrouillée. Vous ne pouvez pas créer de nouvelles pré-conventions tant qu'une est verrouillée.",
  "You don't have any internship agreements yet. Create one to get started.":
    "Vous n'avez pas encore de pré-convention de stage. Créez-en une pour commencer.",
  "Active - Draft Mode": "Active - Mode brouillon",
  "Submit for validation": "Soumettre pour validation",
  "Archive this convention": "Archiver cette pré-convention",
  "Awaiting Teacher Validation": "En attente de validation enseignant",
  "Move back to draft mode for editing": "Revenir au mode brouillon pour modification",
  "Back to Draft": "Retour au brouillon",
  "Feedback requested on": "Validation demandée le",
  "teachers validated": "enseignants ont validé",
  "Validated by All Teachers": "Validée par tous les enseignants",
  "Fully Validated!": "Entièrement validée !",
  "All teachers have approved your internship agreement.": "Tous les enseignants ont approuvé votre pré-convention de stage.",
  "See below the feedback history, the current version is Version": "Voir ci-dessous l'historique des retours, la version actuelle est la version",
  "Feedback History": "Historique des retours",
  "Version": "Version",
  "by": "par",
  "on": "le",
  "Notification received": "Notification reçue",
  "Validated by": "Validé par",
  "teacher(s)": "enseignant(s)",
  "Validators": "Validateurs",
  "Title": "Titre",
  "Business": "Entreprise",
  "Period": "Période",
  "This convention was validated by all teachers": "Cette pré-convention a été validée par tous les enseignants",
  "Restore this convention as validated": "Restaurer cette pré-convention comme validée",
  "Make this convention active": "Activer cette pré-convention",
  "Restore": "Restaurer",
  "Activate": "Activer",
  "Edit non-critical fields": "Modifier les champs non critiques",
  "You can still edit fields that don't require teacher validation. Click Edit to modify them.":
    "Vous pouvez toujours modifier les champs qui ne nécessitent pas de validation par un enseignant. Cliquez sur Modifier pour les modifier.",
  
  // Actions
  "Edit": "Modifier",
  "Delete": "Supprimer",
  "Cancel": "Annuler",
  "Archive": "Archiver",
  "Request Feedback": "Demander une validation",
  "Make Active": "Remettre en cours",
  "View": "Voir",
  "Download PDF": "Télécharger le PDF",
  
  // Confirmation messages
  "Are you sure you want to request feedback? This will make your convention visible to teachers for validation.": 
    "Êtes-vous sûr de vouloir demander une validation ? Cela rendra votre pré-convention visible aux enseignants pour validation.",
  "This convention was previously validated. It will be restored as a validated convention. Continue?": 
    "Cette pré-convention a été précédemment validée. Elle sera restaurée en tant que pré-convention validée. Continuer ?",
  "Moving back to draft mode will hide this convention from teachers. You will need to request feedback again after making your changes. Continue?": 
    "Repasser en mode brouillon masquera cette pré-convention aux enseignants. Vous devrez demander une validation à nouveau après vos modifications. Continuer ?",
  "Are you sure you want to archive this convention?": 
    "Êtes-vous sûr de vouloir archiver cette pré-convention ?",
  "Are you sure you want to delete this convention?": 
    "Êtes-vous sûr de vouloir supprimer cette pré-convention ?",
  
  // Status
  "Status": "Statut",
  "Draft": "Brouillon",
  "Pending": "En attente",
  "Validated": "Validée",
  "Archived": "Archivée",
  "Active": "Active",
  "Locked": "Verrouillée",
  "Lock": "Verrouiller",
  "Unlock": "Déverrouiller",
  "Locked Convention": "Pré-convention verrouillée",
  "Locked Conventions": "Pré-conventions verrouillées",
  "Locked by Administrator": "Verrouillée par un administrateur",
  "This convention is locked.": "Cette pré-convention est verrouillée.",
  "You cannot modify or archive it. Contact an administrator if you need changes.": "Vous ne pouvez ni la modifier ni l'archiver. Contactez un administrateur si vous avez besoin de modifications.",
  "Lock this convention": "Verrouiller cette pré-convention",
  "Unlock this convention": "Déverrouiller cette pré-convention",
  "Fully Validated Conventions": "Pré-conventions entièrement validées",
  "Pending Teacher Validation": "En attente de validation enseignant",
  "Print": "Imprimer",
  "Print this convention": "Imprimer cette pré-convention",
  "Please allow pop-ups to print the convention.": "Veuillez autoriser les pop-ups pour imprimer la pré-convention.",
  "LOCKED CONVENTION": "PRÉ-CONVENTION VERROUILLÉE",
  "Academic Year": "Année universitaire",
  "Convention Details": "Détails de la pré-convention",
  "Validations": "Validations",
  "Validator": "Validateur",
  "Date": "Date",
  "This convention is locked by an administrator and cannot be modified.": "Cette pré-convention est verrouillée par un administrateur et ne peut pas être modifiée.",
  "This convention is locked by an administrator and cannot be deleted.": "Cette pré-convention est verrouillée par un administrateur et ne peut pas être supprimée.",
  "You have a locked convention. You cannot create a new convention while one is locked. Please contact an administrator.": "Vous avez une pré-convention verrouillée. Vous ne pouvez pas créer de nouvelle pré-convention tant qu'une est verrouillée. Veuillez contacter un administrateur.",
  "You have a locked convention. You cannot modify any conventions while one is locked. Please contact an administrator.": "Vous avez une pré-convention verrouillée. Vous ne pouvez modifier aucune pré-convention tant qu'une est verrouillée. Veuillez contacter un administrateur.",
  "You have a locked convention. You cannot change the status of any conventions while one is locked. Please contact an administrator.": "Vous avez une pré-convention verrouillée. Vous ne pouvez changer le statut d'aucune pré-convention tant qu'une est verrouillée. Veuillez contacter un administrateur.",
  "You have a locked convention. You cannot delete any conventions while one is locked. Please contact an administrator.": "Vous avez une pré-convention verrouillée. Vous ne pouvez supprimer aucune pré-convention tant qu'une est verrouillée. Veuillez contacter un administrateur.",
  
  // Months (for dates)
  "Limited editing mode": "Mode édition limitée",
  "Only fields that don't require teacher validation can be edited. Fields requiring validation are disabled.":
    "Seuls les champs qui ne nécessitent pas de validation par un enseignant peuvent être modifiés. Les champs nécessitant une validation sont désactivés.",
  "Requires teacher validation": "Nécessite une validation par un enseignant",
  
  // Teacher View
  "Pending Review": "En attente de relecture",
  "Reviewed": "Relues",
  "Student": "Étudiant",
  "Year": "Année",
  "Review": "Relire",
  "View Details": "Voir les détails",
  "Feedback": "Retour",
  "Mark as Validated": "Marquer comme validée",
  "Mark as Needs Changes": "Nécessite des modifications",
  "Save (No Notification)": "Enregistrer (sans notification)",
  "Save & Notify Student": "Enregistrer et notifier l'étudiant",
  "Save & Send Notification": "Enregistrer et envoyer une notification",
  "Close": "Fermer",
  "Send Notification": "Envoyer une notification",
  "Save without sending notification to student": "Enregistrer sans envoyer de notification à l'étudiant",
  "Save and send notification to student": "Enregistrer et envoyer une notification à l'étudiant",
  "Send notification to student about this feedback": "Envoyer une notification à l'étudiant concernant ce retour",
  "The convention will return to draft mode for the student, and they will receive a notification. Continue?": "La convention retournera en mode brouillon pour l'étudiant, et il recevra une notification. Continuer ?",
  "Resubmitted": "Resoumise",
  "This convention has been resubmitted after receiving feedback.": 
    "Cette convention a été resoumise après avoir reçu des retours.",
  "Previous feedback can be found below.": "Les retours précédents se trouvent ci-dessous.",
  "Teacher Dashboard": "Tableau de bord enseignant",
  "You are not assigned as a validator for any class yet.": "Vous n'êtes pas encore assigné comme validateur pour une classe.",
  "No internship agreements in this class yet.": "Aucune pré-convention de stage dans cette classe pour le moment.",
  "Pending Agreements": "Pré-conventions en attente",
  "Validated Agreements": "Pré-conventions validées",
  "Validate": "Valider",
  "Validated by you": "Validée par vous",
  "Subject": "Sujet",
  "Skills": "Compétences",
  "Address": "Adresse",
  "Supervisor": "Responsable",
  "to": "à",
  "Validation Status": "Statut de validation",
  "Teacher Feedback:": "Retour enseignant :",
  "No feedback for current version": "Pas de retour pour la version actuelle",
  "Validated by:": "Validée par :",
  "Not validated yet": "Pas encore validée",
  "Waiting for validation from": "En attente de validation de",
  "Teacher Feedback": "Retour enseignant",
  "Save Draft": "Enregistrer le brouillon",
  "Last updated": "Dernière mise à jour",
  "No feedback draft": "Pas de brouillon de retour",
  "Edit Feedback": "Modifier le retour",
  "Add Feedback": "Ajouter un retour",
  "Notification sent": "Notification envoyée",
  "Fully Validated": "Entièrement validée",
  "Hide Details": "Masquer les détails",
  "Show Details": "Afficher les détails",
  "Locked Agreements": "Pré-conventions verrouillées",
  "These agreements have been locked by an administrator and cannot be modified.": "Ces pré-conventions ont été verrouillées par un administrateur et ne peuvent plus être modifiées.",
  "Returned for Revision": "Retournées pour révision",
  "In Revision": "En révision",
  "These agreements were returned to the student with feedback and are being revised.": "Ces pré-conventions ont été retournées à l'étudiant avec des commentaires et sont en cours de révision.",
  "Last Feedback Sent": "Dernier retour envoyé",
  "Hide Feedback History": "Masquer l'historique des retours",
  "Show Feedback History": "Afficher l'historique des retours",
  
  // Admin
  "Users": "Utilisateurs",
  "Promotions": "Promotions",
  "Years": "Années",
  "Email Templates": "Modèles d'email",
  "Notifications": "Notifications",
  "Convention Structure": "Structure des pré-conventions",
  "Username": "Nom d'utilisateur",
  "Full Name": "Nom complet",
  "Email": "Email",
  "Role": "Rôle",
  "Promotion": "Promotion",
  "Actions": "Actions",
  "default": "par défaut",
  "Default email based on username and role": "Email par défaut basé sur le nom d'utilisateur et le rôle",
  "Manage Users": "Gérer les utilisateurs",
  "Manage Promos": "Gérer les promotions",
  "Manage Years": "Gérer les années",
  "Form Structure": "Structure du formulaire",
  "Notification Log": "Journal des notifications",
  
  // Roles
  "admin": "Administrateur",
  "teacher": "Enseignant",
  "student": "Étudiant",
  
  // Loading & Errors
  "Loading...": "Chargement...",
  "Error": "Erreur",
  "Success": "Succès",
  
  // AdminUsers
  "Generate Teacher Invite Link": "Générer un lien d'invitation enseignant",
  "Teacher invite link (valid for 7 days)": "Lien d'invitation enseignant (valide pendant 7 jours)",
  "Link copied to clipboard!": "Lien copié dans le presse-papiers !",
  "Search by username or fullname": "Rechercher par nom d'utilisateur ou nom complet",
  "Copy": "Copier",
  "Class": "Classe",
  "Add User": "Ajouter un utilisateur",
  
  // AdminPromos
  "Add Promo": "Ajouter une promotion",
  "Id": "Id",
  "Name": "Nom",
  "No validators": "Aucun validateur",
  "Remove validator": "Retirer le validateur",
  "Add Validator": "Ajouter un validateur",
  "Add Validator to": "Ajouter un validateur à",
  "Select a teacher to add as validator:": "Sélectionnez un enseignant à ajouter comme validateur :",
  "Not implemented": "Pas encore implémenté",
  "save": "enregistrer",
  "edit": "modifier",
  "delete": "supprimer",
  "cancel": "annuler",
  
  // AdminYears
  "Academic Year Management": "Gestion de l'année universitaire",
  "Current Academic Year": "Année universitaire actuelle",
  "Important:": "Important :",
  "WARNING: Changing the academic year will reset ALL student promo assignments. Students will need to select their promo again. This action cannot be undone. Are you sure you want to proceed?": 
    "ATTENTION : Changer l'année universitaire réinitialisera TOUTES les affectations de promotion des étudiants. Les étudiants devront sélectionner à nouveau leur promotion. Cette action ne peut pas être annulée. Êtes-vous sûr de vouloir continuer ?",
  "Changing the academic year will reset all student promo assignments. Students will need to select their promo again when they login.":
    "Changer l'année universitaire réinitialisera toutes les affectations de promotion des étudiants. Les étudiants devront sélectionner à nouveau leur promotion lors de leur connexion.",
  "Loading current year setting...": "Chargement du paramètre d'année actuelle...",
  "Set Current Academic Year": "Définir l'année universitaire actuelle",
  "This setting determines the academic year for new conventions.": "Ce paramètre détermine l'année universitaire pour les nouvelles conventions.",
  "Update Academic Year": "Mettre à jour l'année universitaire",
  "Academic year updated successfully.": "Année universitaire mise à jour avec succès.",
  "students": "étudiants",
  "had their promo reset": "ont vu leur promotion réinitialisée",
  "Failed to update academic year": "Échec de la mise à jour de l'année universitaire",
  "View Conventions by Year": "Voir les pré-conventions par année",
  "Select Year": "Sélectionner l'année",
  "Choose a year...": "Choisissez une année...",
  "Select a year to view pending and validated conventions.": "Sélectionnez une année pour voir les pré-conventions en attente et validées.",
  "Conventions for": "Pré-conventions pour",
  "Loading conventions...": "Chargement des pré-conventions...",
  "No pending or validated conventions found for": "Aucune pré-convention en attente ou validée trouvée pour",
  "No conventions in this class.": "Aucune pré-convention dans cette classe.",
  
  // AdminEmailTemplates
  "Email Template Management": "Gestion des modèles d'email",
  "Loading templates...": "Chargement des modèles...",
  "Error loading templates": "Erreur de chargement des modèles",
  "No description": "Pas de description",
  "Edit Template": "Modifier le modèle",
  "Description": "Description",
  "Body": "Corps",
  "Use placeholders like {{student_name}}, {{teacher_name}}, and {{base_url}}.":
    "Utilisez des placeholders comme {{student_name}}, {{teacher_name}}, et {{base_url}}.",
  "Save Changes": "Enregistrer les modifications",
  "Select a template to edit": "Sélectionnez un modèle à modifier",
  "Template updated successfully": "Modèle mis à jour avec succès",
  "Failed to update template": "Échec de la mise à jour du modèle",
  
  // AdminConventionStructure
  "Convention Structure Management": "Gestion de la structure des pré-conventions",
  "Warning": "Attention",
  "Changing the convention structure will affect all existing and new conventions. Remove fields with caution as this may result in data loss.":
    "Modifier la structure des pré-conventions affectera toutes les pré-conventions existantes et nouvelles. Supprimez les champs avec précaution car cela peut entraîner une perte de données.",
  "Form Fields": "Champs du formulaire",
  "Add Field": "Ajouter un champ",
  "Loading convention structure...": "Chargement de la structure des pré-conventions...",
  "No fields have been defined yet. Click \"Add Field\" to create your first field.":
    "Aucun champ n'a encore été défini. Cliquez sur \"Ajouter un champ\" pour créer votre premier champ.",
  "Are you sure you want to remove this field? This may affect existing conventions.":
    "Êtes-vous sûr de vouloir supprimer ce champ ? Cela peut affecter les pré-conventions existantes.",
  "All fields must have a name and label": "Tous les champs doivent avoir un nom et un libellé",
  "Duplicate field name": "Nom de champ en double",
  "Convention structure updated successfully": "Structure des pré-conventions mise à jour avec succès",
  "Failed to update convention structure": "Échec de la mise à jour de la structure des pré-conventions",
  "Edit this field": "Modifier ce champ",
  "Move up": "Monter",
  "Move down": "Descendre",
  "Remove this field": "Supprimer ce champ",
  "Remove": "Supprimer",
  "Field Name (ID)": "Nom du champ (ID)",
  "Unique identifier for the field (no spaces)": "Identifiant unique pour le champ (sans espaces)",
  "Field Label": "Libellé du champ",
  "Display label": "Libellé d'affichage",
  "This text will be shown to users": "Ce texte sera affiché aux utilisateurs",
  "Field Type": "Type de champ",
  "Required field": "Champ obligatoire",
  "Done": "Terminé",
  "Save Structure": "Enregistrer la structure",
  "Preview": "Aperçu",
  "Enter": "Entrer",
  "Add some fields to see a preview of the convention form": "Ajoutez des champs pour voir un aperçu du formulaire de pré-convention",
  "Group header - following fields will be grouped under this section": "En-tête de groupe - les champs suivants seront regroupés sous cette section",
  "Groups are used to organize fields visually and cannot be required": "Les groupes servent à organiser les champs visuellement et ne peuvent pas être obligatoires",
  "Marks the end of a group section": "Marque la fin d'une section de groupe",
  
  // AdminConventions
  "All Internship Agreements": "Toutes les pré-conventions de stage",
  "You are offline.": "Vous êtes hors ligne.",
  "Viewing cached data in read-only mode.": "Affichage des données en cache en mode lecture seule.",
  "No internship agreements found for the current year.": "Aucune pré-convention de stage trouvée pour l'année en cours.",
  "No agreements in this class.": "Aucune pré-convention dans cette classe.",
  "Validation": "Validation",
  "Not validated by": "Non validé par",
  "Student Information": "Informations étudiant",
  "Business Information": "Informations entreprise",
  "Internship Details": "Détails du stage",
  "Required Skills": "Compétences requises",
  "Not validated by any teacher yet.": "Pas encore validé par un enseignant.",
  
  // Months (for dates)
  "January": "Janvier",
  "February": "Février",
  "March": "Mars",
  "April": "Avril",
  "May": "Mai",
  "June": "Juin",
  "July": "Juillet",
  "August": "Août",
  "September": "Septembre",
  "October": "Octobre",
  "November": "Novembre",
  "December": "Décembre",
};

type TranslationKey = keyof typeof translations;

const I18nContext = createContext<(key: string) => string>();

export function I18nProvider(props: { children: JSX.Element }) {
  const t = (key: string): string => {
    return translations[key as TranslationKey] || key;
  };

  return (
    <I18nContext.Provider value={t}>
      {props.children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useI18n must be used within I18nProvider");
  }
  return context;
}

// Helper function for standalone use
export const t = (key: string): string => {
  return translations[key as TranslationKey] || key;
};
